/**
 * CRM Page Constants
 * Constantes de filtros e opções para a página de CRM.
 */

// Opções de Duração de Plano
export const DURATION_OPTIONS = [
    { value: "", label: "Todos" },
    { value: "monthly", label: "Mensal" },
    { value: "quarterly", label: "Trimestral" },
    { value: "semiannual", label: "Semestral" },
    { value: "yearly", label: "Anual" },
];

// Estado inicial dos filtros
export const INITIAL_FILTERS = {
    search: "",
    status: "",
    gender: "",
    membershipId: "",
    durationType: "",
    contractStartDate: "",
    contractEndDate: "",
    activityId: "",
    ageMin: "",
    ageMax: "",
    employeeId: "",         // Professor
    consultantId: "",       // Consultor (Venda)
    saleStartDate: "",
    saleEndDate: "",
};

// Quantidade de resultados por página
export const PAGE_SIZE = 50;
